class Globals {
  BASE_STORAGE = process.env.REACT_APP_BASE_STORAGE || "";
  BASE = process.env.REACT_APP_BASE || "";

  fromPhotos(url) {
    if (!url) return "";
    if (url.startsWith("http://") || url.startsWith("https://")) {
      return url;
    }
    return this.BASE_STORAGE + url;
  }

  showLoading() {
    // Implementación web
  }

  quitLoading() {
    // Implementación web
  }

  formatMiles = (n, decimals = true, currency = "$") => {
    n = Math.round(n * 100) / 100;

    var c = isNaN((c = Math.abs(c))) ? (decimals ? 2 : 0) : c,
      d = ",",
      t = ".",
      s = n < 0 ? "-" : "",
      i = String(parseInt((n = Math.abs(Number(n) || 0).toFixed(c)))),
      j = (j = i.length) > 3 ? j % 3 : 0;

    const amount =
      s +
      (j ? i.substr(0, j) + t : "") +
      i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) +
      (c
        ? d +
          Math.abs(n - i)
            .toFixed(c)
            .slice(2)
        : "");
    return (currency != null ? currency + " " : "") + amount;
  };

  sendToast(message) {
    // Usando react-hot-toast por defecto en web
    // import toast from "react-hot-toast"; (manejar según prefieras o usar console/alert)
  }

  validateDouble(value) {
    return /^[+]?([0-9]+(?:[\.][0-9]*)?|\.[0-9]+)$/.test(value);
  }

  validateInteger(value) {
    return /^\d+$/.test(value);
  }

  validateIntegerNegative(value) {
    return /^[+-]?\d+$/.test(value);
  }

  clone = (data) => {
    return JSON.parse(JSON.stringify(data));
  };

  clean = (_string) => {
    var specialChars = "!@#$^&%*()+=-[]\\/{}|:<>?,.";
    for (var i = 0; i < specialChars.length; i++) {
      _string = _string.replace(new RegExp("\\" + specialChars[i], "gi"), "");
    }
    _string = _string.toLowerCase();
    _string = _string.replace(/ /g, "_");
    _string = _string.replace(/á/gi, "a");
    _string = _string.replace(/é/gi, "e");
    _string = _string.replace(/í/gi, "i");
    _string = _string.replace(/ó/gi, "o");
    _string = _string.replace(/ú/gi, "u");
    _string = _string.replace(/ñ/gi, "n");
    return _string;
  };

  getYoutubeID = (url) => {
    var ID = "";
    url = url
      .replace(/(>|<)/gi, "")
      .split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
    if (url[2] !== undefined) {
      ID = url[2].split(/[^0-9a-z_\-]/i);
      ID = ID[0];
    } else {
      ID = url;
    }
    return ID;
  };

  calculateDistance(lat1, lon1, lat2, lon2) {
    var R = 6371;
    var dLat = this.deg2rad(lat2 - lat1);
    var dLon = this.deg2rad(lon2 - lon1);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(this.deg2rad(lat1)) *
        Math.cos(this.deg2rad(lat2)) *
        Math.sin(dLon / 2) *
        Math.sin(dLon / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    var d = R * c;
    return d;
  }

  deg2rad(deg) {
    return deg * (Math.PI / 180);
  }

  isURL(url) {
    const regex =
      /((([A-Za-z]{3,9}:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)/;
    return regex.test(url);
  }
}

export default new Globals();
